const axios = require('axios');
const token = require('./../config/config').token;

module.exports.fetchDevices = (mode) => {
    return axios.post('/api/devices', {'token': token, 'mode': mode})
        .then(res => {
            return res.data;
        }).catch(err => {
            throw new Error(err.message)
        });
}

module.exports.fetchApps = () => {
    return axios.post('/api/getApps', {'token': token})
        .then((res) => {
            var apps = res.data;
            return apps;
        })
        .catch((err) => {
            throw new Error(err.message)
        });
}

module.exports.fetchLogs = (uuid) => {
    return axios.post('/api/es', {'token': token, 'deviceID': uuid})
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            throw new Error(err.message)
        });
}

module.exports.balenaLogs = (uuid) => {
    return axios.post('/api/balenaLogs', {'token': token, 'deviceID': uuid})
        .then((res) => {
            return { 'data': res.data, 'success': true };
        })
        .catch((err) => {
            console.error("error : ", err.message);
            return { 'data': [{'message': err.message}], 'success': false };
        });
}

module.exports.rebootDevice = (uuid) => {
    return axios.post('/api/reboot', {'token': token, 'deviceID': uuid})
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return { message: err.message, success: false };
        })
}

module.exports.forceUpdateDevice = (uuid) => {
    return axios.post('/api/force-update', {'token': token, 'deviceID': uuid})
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return { message: err.message, success: false };
        })
}

module.exports.storeCache = (data) =>{
    return axios.post('/api/store-cache', {'token': token, 'data': data})
        .then(res=>{
            return res.data
        })
        .catch(err=>{
            return {message: err.message, success:false}
        })
}

module.exports.restartApp = (uuid, appID) => {
    return axios.post('/api/restart', {'token': token, 'deviceID': uuid, 'appID': appID})
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return { 'message': err.message, 'success': false };
        })
}

module.exports.services = (uuid) => {
    return axios.post('/api/services', {'token': token, 'deviceID': uuid})
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            return { 'message': err.message, 'success': false };
        })
}

module.exports.deleteDevice = (uuid) => {
    return axios.post('/api/delete', {'token': token, 'deviceID': uuid})
        .then((res) => {
            return res.data;
        })
        .catch(err => {
            return { 'message': err.message, 'success': false };
        })
}

module.exports.getAppReleases = (appId) => {
    return axios.post('/api/getAppReleases', {'token': token, 'appID': appId})
        .then((res) => {
            return res.data;
        })
        .catch(err => {
            return { 'message': [err.message], 'success': false };
        })
}

module.exports.pinToRelease = (uuid, release) => {
    return axios.post('/api/pinToRelease', {'token': token, 'uuid': uuid, 'release': release})
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return { 'message': err.message, 'success': false };
        })
}

module.exports.lockOverride = (uuid, action) => {
    return axios.post('/api/lockOverride', {'token': token, 'uuid': uuid, 'action': action})
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            return { 'message': err.message, 'success': false };
        })
}

module.exports.startStopRestartService = (uuid, imageId, action) => {
    return axios.post('/api/startStopRestartService', {'token': token, 'uuid': uuid, 'imageID': imageId, 'action': action})
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            return { 'message': err.message, 'success': false };
        })
}

module.exports.purgeDevice = (uuid) => {
    return axios.post('/api/purge', {'token': token, 'uuid': uuid})
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            return { 'message': err.message, 'success': false };
        })
}

module.exports.updateAll = (data) => {
    console.log('requesting update all', data);
    return axios.post('/api/updateAll', {'token': token, 'data': data})
        .then(res => {
            return res;
        }).catch((err) => {
            throw new Error(err.message)
        });
}

module.exports.deviceFromCloud = (data) => {
    return axios.post('/api/deviceFromCloud', {'token': token, 'data': data})
        .then(res => {
            return res;
        }).catch((err) => {
            throw new Error(err.message)
        });
}

module.exports.deviceStoreFlags = (data) => {
    return axios.post('/api/deviceStoreFlags', {'token': token, 'data': data})
        .then(res => {
            return res;
        }).catch((err) => {
            throw new Error(err.message)
        });
}

module.exports.setDeviceStoreFlags = (data) => {
    return axios.post('/api/setDeviceStoreFlags', {'token': token, 'data': data})
        .then(res => {
            return res;
        }).catch((err) => {
            throw new Error(err.message)
        });
}

module.exports.deviceLogLevel = (data) => {
    return axios.post('/api/deviceLogLevel', {'token': token, 'data': data})
        .then(res => {
            return res;
        }).catch((err) => {
            throw new Error(err.message)
        });
}

module.exports.deviceVersion = (data) =>{
    return axios.post('/api/deviceVersion', {'token': token, 'data': data})
        .then(res=>{
            return res;
        }).catch(err=>{
            throw new Error(err.message)
        });
}

module.exports.setDeviceLogLevel = (data) => {
    return axios.post('/api/setDeviceLogLevel', {'token': token, 'data': data})
        .then(res => {
            return res;
        }).catch((err) => {
            throw new Error(err.message)
        });
}

module.exports.getUser = () =>{
    return axios.get('/api/user')
}

module.exports.getDeviceTags = (macAddress) => {
    return axios.get(`/api/tags/${macAddress}`, {'token': token})
        .then(res => {
            return res.data.data;
        }).catch((err) => {
            throw new Error(err.message)
        });
}

module.exports.addDeviceTag = (macAddress, tag) => {
    return axios.post(`/api/tags/${macAddress}`, {'token': token, 'tag': tag})
        .then(res => {
            return res.data;
        }).catch((err) => {
            throw new Error(err.message)
        });
}

module.exports.removeDeviceTag = (macAddress, tag) => {
    return axios.delete(`/api/tags/${macAddress}`, {data:{'token': token, 'tag': tag}})
        .then(res => {
            return res.data;
        }).catch((err) => {
            throw new Error(err.message)
        });
}

module.exports.getDeviceNotes = (macAddress) => {
    return axios.get(`/api/notes/${macAddress}`, {'token': token})
        .then(res => {
            return res.data.data;
        }).catch((err) => {
            throw new Error(err.message)
        });
}

module.exports.updateDeviceNotes = (macAddress, notes) => {
    return axios.post(`/api/notes/${macAddress}`, {'token': token, 'notes': notes})
        .then(res => {
            return res.data;
        }).catch((err) => {
            throw new Error(err.message)
        });
}


// WEBPACK FOOTER //
// ./src/api/index.js